<template>
  <div class="navbar-wrapper">
    <div class="container">
      <nav class="navbar" role="navigation">
        <div class="navbar-header">
          <a class="navbar-brand" href="./">
            <img src="assets/images/logo.png" alt="">
          </a>
        </div>
        <div id="navbar" class="navbar-collapse collapse">
          <ul class="nav navbar-nav">
            <li class="active has-popover">
              <a href="./products.html">PRODUCTS</a>
              <div class="popover bottom" id="productPopover">
                <div class="arrow"></div>
                <div class="popover-content">
                  <div class="popover-product-new">
                    <a href="./docode.html">DOCODE<span class="label label-danger">NEW</span></a>
                  </div>
                  <div class="popover-products-wrapper">
                    <ul>
                      <li><a href="./products.html#smartAPP">{{ t('smartAPP') }}</a></li>
                      <li><a href="./products.html#cashierAggregator">{{ t('cashierAggregator') }}</a></li>
                      <li><a href="./products.html#visibleDashboard">{{ t('visibleDashboard') }}</a></li>
                    </ul>
                    <ul>
                      <li><a href="./products.html#elitePOS">{{ t('elitePOS') }}</a></li>
                      <li><a href="./products.html#embraceCapability">{{ t('embraceCapability') }}</a></li>
                      <li><a href="./products.html#beyondImagin">{{ t('beyondImagination') }}</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li><a href="./start.html">HOW TO START</a></li>
            <li><a href="./about.html">ABOUT US</a></li>
          </ul>
        </div>
        <language-switch id="languageSwitch"></language-switch>
      </nav>
    </div>
  </div>
</template>
<script>
  import LanguageSwitch from './LanguageSwitch';

  const HOVER_CLASS = 'hover';
  export default {
    name: 'Navigator',
    components: {
      LanguageSwitch
    },
    locales: {
      en: {
        smartAPP: 'SMART APP',
        cashierAggregator: 'CASHIER AGGREGATOR',
        visibleDashboard: 'VISIBLE DASHBOARD',
        elitePOS: 'ELITE POS',
        embraceCapability: 'EMBRACE CAPABILITY',
        beyondImagination: 'BEYOND IMAGINATION',
      },
      jp: {
        smartAPP: 'スマートAPP',
        cashierAggregator: 'PCレジ',
        visibleDashboard: 'データ可視化',
        elitePOS: 'スマートCCT端末',
        embraceCapability: '拡張性',
        beyondImagination: 'ビジョン',
      }
    }
  };

</script>
<style lang="less">
  .navbar-wrapper {
    min-width: 1180px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 20;
    margin-top: 20px;
    >.container {
      margin: 0 50px;
    }
  }
  
  .navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .navbar-nav {
    margin: 0;
    padding-left: 0;
    list-style: none;
    margin-right: 150px;
    >li {
      position: relative;
      display: block;
      float: left;
      margin-right: 50px;
      &.has-popover:hover {
        .popover {
          display: block;
        }
      }
      >a {
        text-decoration: none;
        position: relative;
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;
        line-height: 20px;
        color: #FFF;
        font-weight: bold;
        font-size: 14px;
        &:hover {
          color: #A5DBF7;
        }
      }
    }
  }
  
  .popover-product-new {
    text-align: center;
    margin-bottom: 10px;
    border-bottom: 1px solid #ddd;
    &:hover>a {
      color: #767676;
    }
    >a {
      margin: 0 0 5px;
      display: inline-block;
      font-weight: bold;
      text-decoration: none;
      position: relative;
      color: #2395CF;
      font-size: 18px;
      .label {
        position: absolute;
        margin-left: 8px;
        margin-top: 3px;
        display: inline-block;
        font-size: 10px;
        padding: .3em .6em .2em;
      }
    }
  }
  
  .popover-products-wrapper {
    width: 100%;
    display: flex;
  }
  
  .popover-products-wrapper ul {
    list-style: none;
    padding: 0;
    display: inline-block;
  }
  
  .popover-products-wrapper ul li {
    margin-bottom: 5px;
  }
  
  .popover-products-wrapper ul li:last-child {
    margin-bottom: 0;
  }
  
  .popover-products-wrapper ul li a {
    text-decoration: none;
    white-space: nowrap;
    font-weight: bold;
  }
  
  .popover-products-wrapper ul:first-of-type {
    margin-right: 60px;
  }
  
  .popover-products-wrapper ul:first-of-type li a {
    color: #2395CF;
  }
  
  .popover-products-wrapper ul:last-of-type li a {
    color: #23CFA4;
  }
  
  .popover-products-wrapper ul li:hover a {
    color: #767676;
  }
  
  .popover {
    position: absolute;
    z-index: 1060;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: left;
    white-space: normal;
    background-color: #fff;
    background-clip: padding-box;
    border-radius: 6px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
    display: none;
  }
  
  .popover>.arrow {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: -5px;
      right: -15px;
      bottom: -11px;
      left: -178px;
      width: 357px;
    }
    &:after {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
    }
  }
  
  .popover>.arrow {
    border-width: 11px;
    border: 10px solid transparent;
  }
  
  .popover.bottom>.arrow {
    top: -11px;
    left: 50%;
    margin-left: -10px;
    border-top-width: 0;
  }
  
  .popover>.arrow:after {
    content: "";
    border-width: 10px;
  }
  
  .popover.bottom>.arrow:after {
    top: 1px;
    margin-left: -10px;
    content: " ";
    border-top-width: 0;
    border-bottom-color: #fff;
  }
  
  .popover-content {
    padding: 0 20px 20px;
    font-family: 'Helvetica Inserat LT', 'Microsoft YaHei';
  }
  
  .japanese .popover-content {
    font-family: inherit;
  }
  
  #productPopover {
    font-family: 'Helvetica Neue', 'Microsoft YaHei';
    width: 356px;
    left: -140px;
    top: 45px;
  }
  
  .japanese #productPopover {
    font-family: inherit;
  }
</style>


// WEBPACK FOOTER //
// Navigator.vue?b81930be